import getExposedPromise from './getExposedPromise';

export default class BasketHelper {
    static request(method, data) {
        return BX.ajax.runComponentAction('nav:ajax.basket', method, {
            mode: 'ajax',
            data
        });
    }

    static add({ offerId, quantity, $button, classPrefix }) {
        const { promise, resolve, reject } = getExposedPromise();

        this.request('add', {
            mode:'ajax',
            data: {
                id: offerId,
                quantity,
            }
        }).then((response) => {
            $(document).trigger($.Event('custom:basketUpdate', response.data));
            resolve(response.data);

            return response;
        }).catch((response) => {
            alert(response.errors.map(item => item.message).join("\n"));
            reject(response);
        });

        return promise;
    }

    static changeQuantity({ basketItemId, quantity, signedParams = null }) {
        const { promise, resolve, reject } = getExposedPromise();

        this.request('changeQuantity', {
            itemId: basketItemId,
            quantity,
            signedParams,
        }).then((response) => {
            $(document).trigger($.Event('custom:basketUpdate', response.data));
            resolve(response.data);
            return response;
        }).catch((response) => {
            alert(response.errors.map(item => item.message).join("\n"));
            reject(response);
        });

        return promise;
    }

    /**
     * @param {Number} basketItemId
     * @param {Object} signedParams
     * @returns {*}
     */
    static remove({ basketItemId, signedParams = null }) {
        const { promise, resolve, reject } = getExposedPromise();

        this.request('delete', {
            itemId: basketItemId,
            signedParams,
        }).then((response) => {
            $(document).trigger($.Event('custom:basketUpdate', response.data));
            resolve(response.data);

            return response;
        }).catch((response) => {
            alert(response.errors.map(item => item.message).join("\n"));
            reject(response);
        });

        return promise;
    }

    static goToBasket() {
        document.location.href = '/basket/';
    }
}